import React from 'react';
import { Box, SxProps, Tooltip } from '@mui/material';
import { CustomAvatar } from '@europrocurement/flexy-components';

type PeoplePreviewProps = {
    firstName?: string;
    lastName?: string;
    userIdentifier?: string;
    sx?: SxProps;
    sxAvatar?: SxProps;
    tooltipTitle?: string;
    onClick?: (e: React.MouseEvent) => void;
    auth?: boolean;
};

const PeoplePreview: React.FunctionComponent<PeoplePreviewProps> = function ({
    firstName,
    lastName,
    userIdentifier,
    sx = {},
    sxAvatar = {},
    onClick = () => {},
    tooltipTitle,
    auth = true,
}) {
    if (!firstName && !lastName) {
        return null;
    }

    const boxStyle = {
        borderRadius: '16px',
        width: '32px',
        height: '32px',
        margin: '0px 16px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        ...sx,
    };

    return (
        <Tooltip title={tooltipTitle || `${firstName} ${lastName}`}>
            <Box sx={boxStyle}>
                <CustomAvatar
                    sx={{
                        width: '32px',
                        height: '32px',
                        ...sxAvatar,
                    }}
                    firstName={firstName}
                    lastName={lastName}
                    keycloakId={userIdentifier}
                    onClick={onClick}
                    auth={auth}
                />
            </Box>
        </Tooltip>
    );
};

export default PeoplePreview;
